const selectors = {
  featuresWrapper: "[data-product-feature-icons]",
  occasionsWrapper: "[data-product-occasion-icons]",
  iconElement: "[data-icon-handle]",
};
// eslint-disable @typescript-eslint/no-explicit-any
const initIcons = (wrapper: string, windowObject: any) => {
  const wrapperElement = document.querySelector(wrapper);

  if (wrapperElement) {
    const iconElements = (wrapperElement as HTMLDivElement).querySelectorAll(
      selectors.iconElement
    );

    if (iconElements) {
      iconElements.forEach((icon) => {
        const iconHandle = (icon as HTMLElement).dataset.iconHandle;
        const [iconData] = windowObject.icons.filter(
          (i: any) => i.handle == iconHandle
        );

        if (iconData) {
          const displayName = iconData.display_name
            ? iconData.display_name
            : iconData.name;
          icon.textContent = displayName;
          icon.innerHTML = `
          ${
            iconData.icon_svg
              ? iconData.icon_svg
              : `<img class="product-icons__icon--image" src="${iconData.icon_image}" alt="${displayName}" />`
          }
          <p class="product-icons__icon--title">${displayName}</p>
          `;
        }
      });
    }
  }
};

if (
  document.readyState === "complete" ||
  document.readyState === "interactive"
) {
  setTimeout(() => {
    initIcons(selectors.featuresWrapper, window.product_features);
    initIcons(selectors.occasionsWrapper, window.product_occasions);
  }, 1);
} else {
  document.addEventListener("DOMContentLoaded", () => {
    initIcons(selectors.featuresWrapper, window.product_features);
    initIcons(selectors.occasionsWrapper, window.product_occasions);
  });
}
